<template>
  <v-container class="links-panel">
    <div class="button-link-container card-section">
      <div class="text-section-header">links</div>
      <v-btn
        v-if="stamenWebsiteLink"
        color="secondary"
        @click="() => handleLinkClick(stamenWebsiteLink)"
      >
        <v-icon>mdi-flower-poppy</v-icon>
        Stamen Website
      </v-btn>
      <v-btn
        v-if="liveProjectLink"
        color="secondary"
        @click="() => handleLinkClick(liveProjectLink)"
      >
        <v-icon>mdi-butterfly-outline</v-icon>
        Live Project
      </v-btn>
      <v-btn
        v-if="blogPostLink"
        color="secondary"
        @click="() => handleLinkClick(blogPostLink)"
      >
        <v-icon>mdi-book-open-variant</v-icon>
        Blog Post
      </v-btn>
      <v-btn
        v-if="prototypeLink"
        color="secondary"
        @click="() => handleLinkClick(prototypeLink)"
      >
        <v-icon>mdi-bacteria-outline</v-icon>
        Prototype
      </v-btn>
      <v-btn
        v-if="sourceCodeLink"
        color="secondary"
        @click="() => handleLinkClick(sourceCodeLink)"
      >
        <v-icon>mdi-barcode</v-icon>
        Source Code
      </v-btn>
    </div>
  </v-container>
</template>

<script>
// vuex
// library
// internal
// components
export default {
  name: 'DetailsPanel',
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      placeholderTalkabout: 'depends'
    }
  },
  computed: {
    acf() {
      return this.data.acf_data
    },

    websiteStatusText() {
      switch (this.data.post_status) {
        case 'publish':
          return 'Public'
        case 'private':
          return 'Private'
        default:
          return this.data.post_status
      }
    },
    websiteStatusChipColor() {
      switch (this.data.post_status) {
        case 'publish':
          return 'success'
        case 'draft':
          return '#FF9800'
        default:
          return 'error'
      }
    },
    stamenWebsiteLink() {
      if (this.data.post_status === 'publish') {
        return `https://stamen.com/work/${this.data.post_name}`
      } else {
        return null
      }
    },
    blogPostLink() {
      return this.getDataOrNull('link_to_blog_post')
    },
    liveProjectLink() {
      return this.getDataOrNull('link_to_live_project')
    },
    sourceCodeLink() {
      return this.getDataOrNull('source_code_link')
    },
    prototypeLink() {
      return this.getDataOrNull('prototype_link')
    }
  },
  methods: {
    getDataOrNull(s) {
      return this.acf[s] === '' ? null : this.acf[s]
    },
    handleLinkClick(link) {
      window.open(link, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.links-panel {
  padding: 0px;

  &__row {
    min-height: 30px;
  }

  &__col {
    padding: 8px 0px;
  }

  &__label {
    font-weight: 600;
  }

  .button-link-container {
    margin-top: 40px;
    display: flex wrap;

    > button {
      margin: 10px 10px 0px 0px;
      color: black;

      i {
        margin-right: 5px;
      }
    }
  }
}
</style>
